module.exports = __webpack_public_path__ + "static/Mudbox-a265cce688a0ccdb052e490fe920d05e.png";